import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const areaApi = createApi({
  reducerPath: 'areaApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getForSelect: builder.query({
      query: (arg) => {
        const { id } = arg;
        return { url: `customer/countries/${id}/areas/for-select` };
      },
    }),
    getForInputForSelect: builder.query({
      query: (arg) => {
        const { id } = arg;
        return { url: `customer/countries/${id}/areas/input/for-select` };
      },
    }),
  }),
});
